import request from "@/api/request";

// 填报项目回款计划
export function saveProjectPaymentPlan(data) {
  return request({
    url: "/finance-service/project-payment-plan/save",
    method: "post",
    data,
  });
}

// 查询当前月的项目回款计划
export function getCurrentMonthPlan(yearMonth) {
  return request({
    url: "/finance-service/project-payment-plan/current-month-plan",
    method: "get",
    params: {
      yearMonth,
    },
  });
}

// 根据年月查询项目回款计划
export function getByYearMonth(yearMonth, deptId, pageNum, pageSize) {
  return request({
    url: "/finance-service/project-payment-plan/get-by-year-month",
    method: "get",
    params: {
      yearMonth,
      deptId,
      pageNum,
      pageSize,
    },
  });
}

// 全院统计接口
export function yearlyStatistics(year) {
  return request({
    url: "/finance-service/project-payment-plan/yearly-statistics",
    method: "get",
    params: {
      year,
    },
  });
}

// 手动触发项目回款计划汇总定时任务
export function triggerSummaryTask() {
  return request({
    url: "/finance-service/project-payment-plan/trigger-summary",
    method: "post",
  });
}

// 手动触发项目回款计划汇总任务（指定年月）
export function summaryTask(yearMonth) {
  return request({
    url: "/finance-service/project-payment-plan/summary-task",
    method: "post",
    params: {
      yearMonth,
    },
  });
}

// 获取指定年月的周信息
export function getWeeks(yearMonth) {
  return request({
    url: "/finance-service/project-payment-plan/get-weeks",
    method: "get",
    params: {
      yearMonth,
    },
  });
}

// 生成回款记录JSON（获取合同的期初值和后续回款记录）
export function generateCollectionJson(params) {
  return request({
    url: "/finance-service/subcontract-payment-plan/generate-collection-json",
    method: "get",
    params,
  });
}